






























































































































































































































































































































import { PageModule } from "@/store/module/page";
import { dateFormat } from "@/utils/timeFormat";
import {
  getFollowAllListData,
  getFollowAllListApi,
  getFollowModeApi,
  getFollowStageApi,
  deletefollowLogApi,
  getFollowLatentApi,
  studentFollowExportApi,
} from "@/api/studentFollow";
import logDetailDialog from "./logDetailDialog.vue";
import logEditDialog from "./logEditDialog.vue";
import logFollowDialog from "./logFollowDialog.vue";
import logCancelDialog from "./logCancelDialog.vue";
import { Vue, Component } from "vue-property-decorator";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { exportLoop } from "@/utils/export";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "followStudentLog",
  components: {
    logDetailDialog,
    logEditDialog,
    logFollowDialog,
    logCancelDialog,
    commonStaffPullDown,
    CommonSearchFormWrapper,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    degree_of_interest: [] as number[],
    pre_follow_date: [] as number[],
    complete_time: [] as string[],
    status: -1,
    follow_date: [] as number[],
    // status: -1,
    follow_up_state: [] as number[],
    staff_id: "",
    staff_list: [],
  };
  followStageList: any[] = [];
  followStageListPlan: any[] = [];
  followStageObj: {} = {};
  followModeList: any[] = [];
  followModeObj: {} = {};
  followLatentList: any[] = [];
  followLatentObj: {} = {};
  tableData: any[] = [];
  multipleSelection: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    const route = this.$route.query;
    if (route.from === "salesData") {
      this.searchInfo.stage = Number(route.key);
      this.searchInfo.complete_time[0] = route.s_time;
      this.searchInfo.complete_time[1] = route.e_time;
    }
    getFollowStageApi({ include_del: 1 }).then((res: any) => {
      const obj: any = {};
      res.data.list.map((item: any) => {
        obj[item.key] = item.value;
      });
      this.followStageList = res.data.list;
    });
    getFollowStageApi({ include_del: 0 }).then((res: any) => {
      const obj: any = {};
      res.data.list.map((item: any) => {
        obj[item.key] = item.value;
      });
      this.followStageListPlan = res.data.list;
      this.followStageObj = obj;
      getFollowModeApi().then((res: any) => {
        const obj: any = {};
        res.data.list.map((item: any) => {
          obj[item.key] = item.value;
        });
        this.followModeList = res.data.list;
        this.followModeObj = obj;
      });
      getFollowLatentApi().then((res: any) => {
        const obj: any = {};
        res.data.list.map((item: any) => {
          obj[item.key] = item.value;
        });
        this.followLatentList = res.data.list;
        this.followLatentObj = obj;
      });
    });
    if (PageModule.latestRoute === "studyDetails") {
      const cache = PageModule.pageInfo.recruitFollowList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    } else if (PageModule.latestRoute === "dashboard") {
      const params = this.$route.params;
      if (params.staff_id) {
        this.searchInfo.staff_id = Number(params.staff_id);
      }
      if (params.follow_start_time && params.follow_end_time) {
        this.searchInfo.pre_follow_date = [
          params.follow_start_time,
          params.follow_end_time,
        ];
      }
      if (params.status) {
        this.searchInfo.follow_up_state = JSON.parse(params.status);
      }
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  resetSearch() {
    this.searchInfo = {
      degree_of_interest: [] as number[],
      pre_follow_date: [] as number[],
      status: -1,
      follow_up_state: [] as number[],
    };
    this.page = 1;
    this.pageSize = 10;
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleRefresh(type?: string) {
    let page = this.page;
    if (
      type === "delete" &&
      (this.page - 1) * this.pageSize + 1 === this.total
    ) {
      page = page - 1;
    }
    this.getList({
      page: page > 0 ? page : 1,
      page_size: this.pageSize,
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: getFollowAllListData = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.key_word) {
      option.key_word = this.searchInfo.key_word;
    }
    if (this.searchInfo.staff_id !== "") {
      option.staff_id = this.searchInfo.staff_id;
    }
    if (this.searchInfo.stage !== "") {
      option.stage = this.searchInfo.stage;
    }
    if (this.searchInfo.mode !== "") {
      option.mode = this.searchInfo.mode;
    }
    if (this.searchInfo.pre_follow_date !== null) {
      if (this.searchInfo.pre_follow_date.length > 0) {
        option.pre_follow_start_time =
          new Date(
            this.searchInfo.pre_follow_date[0].replace(/-/g, "/")
          ).getTime() / 1000;
        option.pre_follow_end_time =
          new Date(
            this.searchInfo.pre_follow_date[1].replace(/-/g, "/")
          ).getTime() /
            1000 +
          (24 * 60 * 60 - 1);
      }
    }
    if (this.searchInfo.complete_time !== null) {
      if (this.searchInfo.complete_time.length > 0) {
        option.follow_start_time = this.searchInfo.complete_time[0];
        option.follow_end_time = this.searchInfo.complete_time[1];
      }
    }
    if (
      this.searchInfo.pre_follow_date &&
      this.searchInfo.pre_follow_date.length === 2
    ) {
      option.pre_follow_start_time =
        new Date(
          this.searchInfo.pre_follow_date[0].replace(/-/g, "/")
        ).getTime() / 1000;
      option.pre_follow_end_time =
        new Date(
          this.searchInfo.pre_follow_date[1].replace(/-/g, "/")
        ).getTime() /
          1000 +
        (24 * 60 * 60 - 1);
    }
    if (
      this.searchInfo.follow_date &&
      this.searchInfo.follow_date.length === 2
    ) {
      option.follow_start_time = this.searchInfo.follow_date[0];
      option.follow_end_time = this.searchInfo.follow_date[1];
    }
    if (this.searchInfo.follow_up_state.length > 0) {
      option.status_arr = this.searchInfo.follow_up_state;
    }
    if (this.searchInfo.degree_of_interest.length > 0) {
      option.intent_arr = this.searchInfo.degree_of_interest;
    }
    getFollowAllListApi(option).then((res: any) => {
      this.page = res.data.page;
      this.total = res.data.total;
      res.data.list.map((item: any) => {
        item.content =
          item.content.length > 20
            ? item.content.slice(0, 20) + "..."
            : item.content;
        item.pre_follow_time =
          item.pre_follow_time === 0
            ? "-"
            : dateFormat("YYYY-mm-dd HH:MM", item.pre_follow_time * 1000);
        item.follow_time =
          item.follow_time === 0
            ? "-"
            : dateFormat("YYYY-mm-dd HH:MM", item.follow_time * 1000);
      });
      this.tableData = res.data.list;
    });
  }
  toStudentDetail(row: any) {
    PageModule.SET_PAGE_INFO({
      name: "recruitFollowList",
      key: "search_info",
      value: { ...this.searchInfo },
    });
    this.$router.push({
      name: "studyDetails",
      query: { id: row.student.student_id, tab: "followup" },
    });
  }
  handleDelete(row: any) {
    this.$confirm("确定删除后，跟进记录将无法恢复。", `删除 - 跟进记录`, {
      confirmButtonText: "确定",
      confirmButtonClass: "mwow-button-filled success mini",
      cancelButtonText: "取消",
      cancelButtonClass: "mwow-button-filled mini",
      iconClass: "mwow-icon-error",
    })
      .then(() => {
        deletefollowLogApi({ follow_id: row.id }).then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.handleRefresh("delete");
        });
      })
      .catch(() => {});
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
    PageModule.SET_PAGE_INFO({
      name: "recruitFollowList",
      key: "page",
      value: e,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  // 导出
  exportList() {
    const data: any = {};
    if (this.searchInfo.key_word) {
      data.key_word = this.searchInfo.key_word;
    }
    if (this.searchInfo.staff_id !== "") {
      data.staff_id = this.searchInfo.staff_id;
    }
    if (this.searchInfo.stage !== "") {
      data.stage = this.searchInfo.stage;
    }
    if (this.searchInfo.mode !== "") {
      data.mode = this.searchInfo.mode;
    }
    if (
      this.searchInfo.pre_follow_date &&
      this.searchInfo.pre_follow_date.length === 2
    ) {
      data.pre_follow_start_time =
        new Date(
          this.searchInfo.pre_follow_date[0].replace(/-/g, "/")
        ).getTime() / 1000;
      data.pre_follow_end_time =
        new Date(
          this.searchInfo.pre_follow_date[1].replace(/-/g, "/")
        ).getTime() /
          1000 +
        (24 * 60 * 60 - 1);
    }
    if (
      this.searchInfo.follow_date &&
      this.searchInfo.follow_date.length === 2
    ) {
      data.follow_start_time = this.searchInfo.follow_date[0];
      data.follow_end_time = this.searchInfo.follow_date[1];
    }
    if (this.searchInfo.follow_up_state.length > 0) {
      data.status_arr = this.searchInfo.follow_up_state;
    }
    if (this.searchInfo.degree_of_interest.length > 0) {
      data.intent_arr = this.searchInfo.degree_of_interest;
    }
    studentFollowExportApi(data).then((res: any) => {
      if (res.error_code === 0) {
        exportLoop(res.data.task_id);
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
}
